export enum FilterType {
  Checkbox = 'checkbox',
  SelectDropdown = 'selectDropdown',
  AutocompleteDropdown = 'autocompleteDropdown',
}
